<template>
    <div class="flex items-center whitespace-nowrap">
      <span
        class="mr-1.5 text-lg underline"
        :class="prevDisabled ? 'opacity-30 cursor-not-allowed' : 'hover:text-accent-primary cursor-pointer'"
        @click="goToFirst"
        >&lt;&lt;</span
      >
      <span
        class="mr-1.5 text-lg underline"
        :class="prevDisabled ? 'opacity-30 cursor-not-allowed' : 'hover:text-accent-primary cursor-pointer'"
        @click="getPrev"
        >&lt;</span
      >
      <div class="flex flex-row">
        Page
        <span
          ><JumpToPage class="mx-1" :current-page="page" :max-page="countIsCapped ? null : numPages" @fetch-page="jumpToPage" v-model="inputtedPage"
        /></span>
            <span v-if="numPages != null">of {{ displayedNumPages }}</span>
      </div>
      <span
        class="ml-1.5 text-lg underline"
        :class="nextDisabled ? 'opacity-30 cursor-not-allowed' : 'hover:text-accent-primary cursor-pointer'"
        @click="getNext"
        >></span
      >
      <span
        v-if="numPages != null && !countIsCapped"
        class="ml-1.5 text-lg underline"
        :class="nextDisabled ? 'opacity-30 cursor-not-allowed' : 'hover:text-accent-primary cursor-pointer'"
        @click="goToLast"
        >>></span
      >
    </div>
  </template>
  
  <script setup>
  import { computed, defineProps, defineEmits, ref } from "vue";
  import JumpToPage from "./JumpToPage.vue"

  const props = defineProps(["page", "numPages", "hasNext", "hasPrev", "countIsCapped", "isPastEnd"]);
  const emit = defineEmits(['go-to-first', 'go-to-last', 'get-prev', 'get-next', 'jump-to-page'])

  const inputtedPage = ref();

  // hasNext/hasPrev are optional — callers that don't pass them keep the old
  // always-clickable behavior, so only an explicit `false` greys an arrow out.
  const nextDisabled = computed(() => props.hasNext === false)
  const prevDisabled = computed(() => props.hasPrev === false)

  // When the backend caps its count, numPages is only the lowest page total we
  // know of. Once we've paged past it the current page is a better floor, and
  // on a page with no next page it's the exact total — so "20+" ... "7".
  const displayedNumPages = computed(() => {
    if (!props.countIsCapped) return props.numPages
    // An empty page past the end proves nothing about the total, so the floor
    // stays where the count left it — "Page 400 of 20+", not "of 400".
    const knownPages = props.isPastEnd
      ? (props.numPages || 0)
      : Math.max(props.numPages || 0, props.page || 0)
    return (nextDisabled.value && !props.isPastEnd) ? knownPages : `${knownPages}+`
  })

  function goToLast() {
      if (nextDisabled.value) return
      emit('go-to-last')
  }
  function goToFirst() {
      if (prevDisabled.value) return
      emit('go-to-first')
  }
  function getPrev() {
      if (prevDisabled.value) return
      emit('get-prev')
  }
  function getNext() {
      if (nextDisabled.value) return
      emit('get-next')
  }
  
  function jumpToPage(pageToJump) {
    emit('jump-to-page', pageToJump);
  }
  </script>
  